import React, { memo } from 'react';
import styles from './ZtImg.module.less';

export default memo(({ data }) => {

  return data && data.content ?
    (
      <div className={styles.card}>
        <img className={styles.card_img} src={data.content.imgUrl} alt="img"/>
      </div>
    ) :
    ''
});